import { IServiceFactory } from '../../common/types/service-factory';
import { AppConfigService, IAppConfigService } from '../interfaces/app-config-service';

export class AppConfigServiceFactory implements IServiceFactory<IAppConfigService> {
	public Create(): IAppConfigService {
		return new AppConfigService();
	}
}
